import { SignedIcon } from '../icons'
import Button from '../buttons/button'
import Counter from '../badgesAndTags/counter'
import { TypographyHeading, TypographyParagraph } from '../typography'
import ExhibitionsTable from './exhibitionsTable.tsx'
import { AttestationType } from '#types/loreTypes.tsx'
import { Await } from '@remix-run/react'
import { Suspense } from 'react'

export default function ProofOfExhibition({
	exhibitions,
	chain,
	contract,
	tokenId,
	showSignButton = false,
	setSignModalOpen,
	subtitle,
}: {
	setSignModalOpen?: (open: boolean) => void
	exhibitions: AttestationType[]
	chain?: string
	contract?: string
	tokenId?: string
	showSignButton?: boolean
	subtitle?: string
}) {
	const nftProfileURL = `/nftProfile/${chain}${chain != 'solana' ? '/' + contract : ''}/${tokenId}`
	return (
		<div className="my-[72px] flex w-full flex-col gap-y-4 px-0 lg:px-12">
			<Suspense fallback={<div>Loading...</div>}>
				<Await resolve={exhibitions}>
					{exhibitions => {
						return (
							<>
								<div className="flex-start flex w-full justify-between">
									<div className="flex w-full flex-col items-start">
										<div className="flex flex-1 items-center gap-x-4">
											<TypographyHeading
												size="medium"
												isBold={true}
												additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark"
											>
												Proof of Exhibition
											</TypographyHeading>
											<Counter
												size="small"
												children={exhibitions ? exhibitions.length : 0}
											/>
										</div>
										{subtitle && (
											<TypographyParagraph
												size="medium"
												additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
											>
												{subtitle}
											</TypographyParagraph>
										)}
									</div>
									{showSignButton && setSignModalOpen && (
										<div className="flex items-center justify-end">
											<Button
												variant="primary"
												size="medium"
												leftIcon={<SignedIcon />}
												onClick={() => setSignModalOpen(true)}
											>
												Sign
											</Button>
										</div>
									)}
								</div>
								<div className="pt-6">
									{exhibitions && exhibitions.length ? (
										<ExhibitionsTable data={exhibitions} showButton={false} />
									) : (
										<div className="mt-12 flex flex-col items-center justify-center">
											<TypographyParagraph
												size="medium"
												additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
											>
												No exhibition history has been signed yet.
											</TypographyParagraph>
										</div>
									)}
								</div>
							</>
						)
					}}
				</Await>
			</Suspense>
		</div>
	)
}
